import { SapEtaItemModel } from './models';

export class SapEtaConfigurationListLoad {
  public static readonly type = '[SapEtaConfiguration] Load List';
}

export class SapEtaConfigurationCreate {
  public static readonly type = '[SapEtaConfiguration] Create';

  constructor(public payload: SapEtaItemModel) {}
}

export class SapEtaConfigurationUpdate {
  public static readonly type = '[SapEtaConfiguration] Update';

  constructor(public payload: SapEtaItemModel) {}
}

export class SapEtaConfigurationDelete {
  public static readonly type = '[SapEtaConfiguration] Delete';

  constructor(public payload: string) {}
}

export class SapEtaConfigurationListInitialState {
  public static readonly type = '[SapEtaConfiguration] Set Initial State';
}

export class SapEtaManualPush {
  public static readonly type = '[SapEtaConfiguration] Manual Push';

  constructor(public payload: string) {}
}
